import { Link } from "react-router-dom";
import type { Anime } from "@/types";

export default function AnimeCard({ anime }: { anime: Anime }) {
  return (
    <Link
      to={`/detail/${anime.id}`}
      className="group flex flex-col bg-background-50 rounded-lg border border-background-200 overflow-hidden hover:border-primary-300 transition-colors cursor-pointer h-full"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-100">
        <img
          src={anime.cover}
          alt={`${anime.title} 动画封面`}
          title={`${anime.title} 日本动画推荐`}
          className="w-full h-full object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-semibold">
          {anime.rating.toFixed(1)}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-background-50/90 text-foreground-800 text-xs font-medium">
          {anime.year}
        </span>
      </div>
      <div className="flex flex-col flex-1 p-4">
        <h3 className="font-heading text-base font-bold text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {anime.title}
        </h3>
        <p className="mt-0.5 text-xs text-foreground-500">{anime.titleJa}</p>
        <div className="flex flex-wrap gap-1.5 mt-3">
          {anime.categories.map((cat) => (
            <span
              key={cat}
              className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-xs"
            >
              {cat}
            </span>
          ))}
        </div>
        <p className="mt-3 text-xs leading-relaxed text-foreground-600 line-clamp-2">{anime.synopsis}</p>
        <div className="mt-auto pt-3 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-play-list-line" />
            {anime.episodes} 集
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-user-star-line" />
            {anime.director}
          </span>
        </div>
      </div>
    </Link>
  );
}